module.exports = __webpack_public_path__ + "img/exchange_illustration.de322b2e.png";